import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSubcontractorProfile } from '@/contexts/SubcontractorProfileContext';

// Archive mode: a terminated crew member's portal has exactly one live page —
// their archive. Every other route lands there. The nav shows the same story
// (locks on everything), but the redirect is what makes it true for a typed
// URL, a bookmark or a push tap.
const ARCHIVE_PATH = '/subcontractor/dashboard/archive';

const ArchiveGate = ({ children }) => {
  const { archiveLocked } = useSubcontractorProfile();
  const location = useLocation();
  if (archiveLocked && location.pathname !== ARCHIVE_PATH) {
    return <Navigate to={ARCHIVE_PATH} replace />;
  }
  // Not terminated — the archive page has nothing for them.
  if (!archiveLocked && location.pathname === ARCHIVE_PATH) {
    return <Navigate to="/subcontractor/dashboard" replace />;
  }
  return children;
};

export default ArchiveGate;
